import { useFormalizeCommunication } from '@ztechapps/chat.common'

export type UseFormalizeMessageResult = {
  formalizing: boolean
  onFormalize: (content: string) => Promise<string>
}

// The formalize call the channel provider and the modal toolbar share (code-rule.md → DRY —
// Rule of Two).
export const useFormalizeMessage = (): UseFormalizeMessageResult => {
  const [formalize, , { loading: formalizing }] = useFormalizeCommunication()

  const onFormalize = async (content: string) => {
    const result = await formalize({ input: { content } })
    return result?.data?.formalizeCommunication ?? ''
  }

  return { formalizing, onFormalize }
}
